module.exports = __webpack_public_path__ + "static/img/产品方案BG.b000fdb7.png";